import React, { useContext, useEffect, useState } from 'react'
import { createOrUpdateAd, deleteAds, getAllAds } from '../services/adminServices';
import { toast } from 'react-toastify';
import { AppContext } from '../context/AppContext';
import { CONFIG } from '../config/general';

const Advertisment = () => {
  const { login } = useContext(AppContext);
  const [modal, setModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [adsData, setAdsData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ads, setAds] = useState({});
  const [pagination, setPagination] = useState({});
  const [data, setData] = useState({ title: '', type: "html", position: 'right', htmlContent: '', isActive: false });
  const [deleteModal, setDeleteModal] = useState({ modal: false, props: {} });
  const [filter, setFilter] = useState({ limit: 10, page: 1, search: "" });

  const loadAds = (req = filter) => {
    getAllAds(login.token, req).then((data) => {
      if (data.code === 5) {
        setAdsData(data.data);
        setPagination(data.pagination);
        setReload(false)
      } else {
        setAdsData([]);
        toast.failure(data.error);
      }
    })
      .catch(error => {
        toast.failure(error);
      })
  };

  const handleNext = () => {
    if (pagination.currentPage < pagination.totalPages) {
      const newPage = pagination.currentPage + 1;
      setFilter({ ...filter, page: newPage });
      loadAds({ ...filter, page: newPage });
    }
  };

  const handlePrev = () => {
    if (pagination.currentPage > 1) {
      const newPage = pagination.currentPage - 1;
      setFilter({ ...filter, page: newPage });
      loadAds({ ...filter, page: newPage });
    }
  };

  const deleteSelectedAds = async (id) => {
    let res = await deleteAds(login.token, id)
    if (res.success) {
      toast.success("Advertisement Deleted Successfully.")
      loadAds()
      setDeleteModal({ modal: false })
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData({
      ...data,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    if (data._id) {
      formData.append('_id', data._id);
    }
    formData.append('title', data.title);
    formData.append('position', data.position);
    formData.append('type', data.type);
    formData.append('isActive', data.isActive);

    if (data.type === 'html') {
      formData.append('htmlContent', data.htmlContent);
    } else if (data.type === 'image' && data.imageFile) {
      formData.append('imageFile', data.imageFile);
    }

    try {
      const response = await createOrUpdateAd(login.token, formData);
      if (response.success) {
        toast.success(response.message);
        setReload(true);
        setData({
          title: '',
          position: 'right',
          htmlContent: '',
          type: 'html',
          isActive: false,
          imageFile: null,
        });
        setIsModalOpen(false);
      } else {
        toast.failure(response.error);
      }
    } catch (error) {
      toast.failure(error);
    }
  };


  useEffect(() => {
    setAds({});
    const getData = setTimeout(loadAds, 500)
    return () => clearTimeout(getData)
  }, [JSON.stringify(filter), reload]);

  return (
    <>
      <div className="details-table mt-3">
        <div className="search-container mb-3">
          <h4>
          <i class="fa-solid fa-rectangle-ad"></i>Advertisement Details :
          </h4>
        </div>
        <div className="add-user py-3 text-end">
          <a onClick={() => { setIsModalOpen(true); setData({ title: '', type: "html", position: 'right', htmlContent: '', isActive: false }) }}>
            <h4>
              <i className="fa-solid me-3 fa-user-plus"></i>
            </h4>
          </a>
        </div>
        <table id="example" className="display" style={{ "width": "100%" }}>
          <thead>
            <tr>
              <th>No</th>
              <th>Title</th>
              <th>Position</th>
              <th>Html Content</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {
              adsData.map((x, i) => {
                return (
                  <tr key={x._id}>
                    <td>{((pagination.currentPage - 1) * filter.limit) + (i + 1)}</td>
                    <td>{x.title}</td>
                    <td >{x.position}</td>
                    <td>{x.type == "image" ? <img style={{ height: "100px" }} alt={x.htmlContent} src={CONFIG.REACT_APP_UPLOADS + "/" + x.htmlContent} /> : x.htmlContent}</td>
                    <td>{x.isActive ? "Active" : "Inactive"}</td>
                    <td className='m-1'>
                      <button
                        className="btn btn-sm btn-info btn-admin-sm m-1"
                        style={{ backgroundColor: '#1edd60', border: "none",color: "#fff" }}
                        onClick={e => {
                          setData({ ...data, ...x })
                          setIsModalOpen(true);
                        }}
                      >Edit</button>
                      <button
                        className="btn btn-sm btn-danger btn-admin-sm"
                        onClick={e => { setDeleteModal({ modal: true, props: x._id }) }}
                      >Delete</button>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <div className="custom-pagination">
          <span className="showing-entries">Showing {(pagination.currentPage - 1) * filter.limit + 1} - {Math.min((pagination.currentPage) * filter.limit, pagination.totalDocuments)} of {pagination.totalDocuments}</span>
          <div className="page-controls">
            <button
              className="page-btn prev"
              onClick={handlePrev}
              disabled={pagination.currentPage === 1} // Disable button on first page
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <span className="current-page">{pagination.currentPage}</span>
            <span className="separator">/</span>
            <span className="total-pages">{pagination.totalPages}</span>
            <button
              className="page-btn next"
              onClick={handleNext}
              disabled={pagination.currentPage === pagination.totalPages} // Disable button on last page
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
      {isModalOpen && <div className="modal show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="adModalLabel">Add Ad</h5>
              <button type="button" className="btn-close" onClick={() => { setIsModalOpen(false) }} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form id="adForm">
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    placeholder="Enter Ad Title"
                    value={data.title}
                    onChange={handleChange}
                  />
                  <span className="text-danger" id="titleError"></span>
                </div>

                <div className="mb-3">
                  <label htmlFor="position" className="form-label">Position</label>
                  <select
                    className="form-select"
                    id="position"
                    name="position"
                    value={data.position}
                    onChange={handleChange}
                  >
                    <option value="right">Right</option>
                    <option value="middle">Middle</option>
                    <option value="left">Left</option>
                    <option value="anywhere">AnyWhere</option>
                  </select>
                  <span className="text-danger" id="positionError"></span>
                </div>

                <div className="mb-3">
                  <label htmlFor="type" className="form-label">Type</label>
                  <select
                    className="form-select"
                    id="type"
                    name="type"
                    value={data.type}
                    onChange={handleChange}
                  >
                    <option value="html">HTML</option>
                    <option value="image">Image</option>
                  </select>
                </div>

                {data.type === "html" ? (
                  <div className="mb-3">
                    <label htmlFor="htmlContent" className="form-label">HTML Content</label>
                    <textarea
                      className="form-control"
                      id="htmlContent"
                      name="htmlContent"
                      value={data.htmlContent}
                      placeholder="Enter Ad HTML Content"
                      rows="3"
                      onChange={handleChange}
                    ></textarea>
                    <span className="text-danger" id="htmlContentError"></span>
                  </div>
                ) : (
                  <div className="mb-3">
                    <label htmlFor="imageFile" className="form-label">Image File</label>
                    <input
                      type="file"
                      className="form-control"
                      id="imageFile"
                      name="imageFile"
                      accept="image/*"
                      onChange={(e) =>
                        setData({
                          ...data,
                          imageFile: e.target.files[0],
                        })
                      }
                    />
                    <span className="text-danger" id="imageFileError"></span>
                  </div>
                )}

                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isActive"
                    checked={data.isActive}
                    name="isActive"
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="isActive">
                    Active
                  </label>
                </div>
              </form>
            </div>


            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => { setIsModalOpen(false) }}>Cancel</button>
              <button type="button" className="btn btn-success"  style={{ backgroundColor: '#1edd60', border: "none" }} onClick={() => { handleSubmit() }}>Add</button>
            </div>

          </div>
        </div>
      </div>}
      {
        <>
          <div className={`modal fade ${deleteModal.modal ? "show d-block" : ""}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Action</h5>
                  <button type="button" className="btn-close" onClick={() => setDeleteModal({ ...deleteModal, modal: false })}></button>
                </div>
                <div className="modal-body">Are you sure you want to delete this item?</div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setDeleteModal({ ...deleteModal, modal: false })}>Cancel</button>
                  <button type="button" className="btn btn-danger" onClick={() => { deleteSelectedAds(deleteModal.props) }}>Delete</button>
                </div>
              </div>
            </div>
          </div>
          {deleteModal.modal && <div className="modal-backdrop fade show" onClick={() => setDeleteModal({ ...deleteModal, modal: false })}></div>}
        </>
      }
    </>
  )
}

export default Advertisment
